import { StoreNames } from 'store/types';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { initialManagementState, managementReducer } from 'store/management/managementSlice';
import { dashboardUIReducer } from './dashboardUISlice/dashboardUISlice';
import { alluraEventReducer } from './calendarManagement/calendarManagementSlice';
import { fullCalendarReducer, initialFullCalendarState } from './fullCalendar/fullCalendarSlice';
import { calendarRateReducer, initialRateState } from './calendarRateSlice/calendarRateSlice';
import { calendarEditRateInitialState, calendarEditRateReducer } from './calendarEditRateSlice/calendarEditRateSlice';
import { calendarEvent } from '@alluradirect/react';
import { initialUIDashboardState } from './dashboardUISlice/constants';

// The Root state is used when you want to pass in a preloaded state into configureStore.
// This is used in testing.
export const rootState = {
  [StoreNames.alluraEvent]: calendarEvent,
  [StoreNames.calendarEditRate]: calendarEditRateInitialState,
  [StoreNames.calendarRate]: initialRateState,
  [StoreNames.dashboard]: initialUIDashboardState,
  [StoreNames.fullCalendar]: initialFullCalendarState,
  [StoreNames.management]: initialManagementState,
};

export const reducer = combineReducers({
  [StoreNames.alluraEvent]: alluraEventReducer,
  [StoreNames.calendarEditRate]: calendarEditRateReducer,
  [StoreNames.calendarRate]: calendarRateReducer,
  [StoreNames.dashboard]: dashboardUIReducer,
  [StoreNames.fullCalendar]: fullCalendarReducer,
  [StoreNames.management]: managementReducer,
});

export const store = configureStore({
  reducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
